import { ApaSizeMatrixBDto } from "../dto/apa-matrix.dto";
import { ApaSizeMatrixEntity } from "../entity/apa-matrix.entity";

export class APaSizeMatrixAdapter {
    public convertDtoToEntity(dto: ApaSizeMatrixBDto): ApaSizeMatrixEntity {
        const entity = new ApaSizeMatrixEntity()
        entity.id = dto.id;
        entity.buyMonth = dto.buyMonth;
        entity.fdOf = dto.fdOf;
        entity.styleNumber = dto.styleNumber; 
        entity.styleType = dto.styleType;
        entity.usaSize = dto.usaSize;
        entity.chinaSizeMatrixtype = dto.chinaSizeMatrixtype;
        entity.chinaTopSize = dto.chinaTopSize;
        entity.chinaTopBodysize = dto.chinaTopBodysize;
        entity.chinaBottomSize = dto.chinaBottomSize;
        entity.chinaBottomBodysize = dto.chinaBottomBodysize;
        entity.koreaSizeMatrixtype = dto.koreaSizeMatrixtype;
        entity.koreaTopGeneric = dto.koreaTopGeneric;
        entity.koreaTopChest = dto.koreaTopChest;
        entity.koreaTopHeight = dto.koreaTopHeight;
        entity.koreaBottomGeneric = dto.koreaBottomGeneric;
        entity.koreaBottomWaist = dto.koreaBottomWaist;
        entity.koreaBottomHip = dto.koreaBottomHip;
        entity.koreaAge = dto.koreaAge;
        entity.ftyShk = dto.ftyShk;
      

        if (dto.id) {
            entity.id = dto.id;
            entity.updatedUser = dto.createdUser;
        } else {
            entity.createdUser = dto.createdUser;
        }
        return entity
    }


    public convertEntityToDto(entity: ApaSizeMatrixEntity): ApaSizeMatrixBDto {

        const dto = new ApaSizeMatrixBDto()
        dto.id = entity.id;
        dto.buyMonth = entity.buyMonth;
        dto.fdOf = entity.fdOf;
        dto.styleNumber = entity.styleNumber;
        dto.styleType = entity.styleType;
        dto.usaSize = entity.usaSize ;
        dto.chinaSizeMatrixtype = entity.chinaSizeMatrixtype
        dto.chinaTopSize = entity.chinaTopSize
        dto.chinaTopBodysize = entity.chinaTopBodysize
        dto.chinaBottomSize = entity.chinaBottomSize
        dto.chinaBottomBodysize = entity.chinaBottomBodysize
        dto.koreaSizeMatrixtype = entity.koreaSizeMatrixtype
        dto.koreaTopGeneric = entity.koreaTopGeneric
        dto.koreaTopChest = entity.koreaTopChest
        dto.koreaTopHeight = entity.koreaTopHeight
        dto.koreaBottomGeneric = entity.koreaBottomGeneric
        dto.koreaBottomWaist = entity.koreaBottomWaist
        dto.koreaBottomHip = entity.koreaBottomHip
        dto.koreaAge = entity.koreaAge
        dto.ftyShk = entity.ftyShk

        dto.createdAt = entity.createdAt
        dto.updatedAt = entity.updatedAt
        dto.updatedUser = entity.updatedUser
        dto.isActive = entity.isActive;
        dto.versionFlag = entity.versionFlag;
        return dto
    }

}